/**
 *
 * Asynchronously loads the component for UpdatePassword
 *
 */

import { lazyLoad } from 'utils/loadable';

export const UpdatePassword = lazyLoad(
  () => import('./index'),
  module => module.UpdatePassword,
);
